import React, { useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { PlaceholderMockup } from './ui/PlaceholderMockup';
import { insideScreenshots } from '../data/sections';
import { INSIDE_IMAGES } from '../data/images';
export function InsideCarousel() {
  const trackRef = useRef<HTMLDivElement>(null);
  const scroll = (dir: 'left' | 'right') => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({
      left: dir === 'left' ? -320 : 320,
      behavior: 'smooth'
    });
  };
  return <section className="bg-mp-black py-20 md:py-28" data-id="element-201" data-mp="2om62a4e07109">
      <Container data-id="element-202" data-mp="2op1zfqi11lnn">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end" data-id="element-203" data-mp="2klvymydoomok">
          <div className="max-w-[650px]" data-id="element-204" data-mp="2yl5bbo2okyns">
            <SectionTag tone="white" data-id="element-205" data-mp="2ylwxy9eavm1x">Sin letra pequeña</SectionTag>
            <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-[2.75rem]" data-id="element-206" data-mp="2tmu0pb4kak4i">
              No te enseñamos solo una portada bonita. Te enseñamos el sistema por dentro.
            </h2>
          </div>

          <div className="hidden gap-2 md:flex" data-id="element-207" data-mp="2rsdjc3rl92e9">
            <button type="button" onClick={() => scroll('left')} aria-label="Ver capturas anteriores" className="flex h-11 w-11 items-center justify-center rounded-full border border-mp-border text-mp-white transition-colors duration-150 hover:border-mp-lime hover:text-mp-lime" data-id="element-208" data-mp="2wqoqg6qi0yss">
              <ChevronLeftIcon className="h-5 w-5" data-id="element-209" data-mp="3ap4wdvgjel9v" />
            </button>
            <button type="button" onClick={() => scroll('right')} aria-label="Ver más capturas" className="flex h-11 w-11 items-center justify-center rounded-full border border-mp-border text-mp-white transition-colors duration-150 hover:border-mp-lime hover:text-mp-lime" data-id="element-210" data-mp="3fj0tywsw264i">
              <ChevronRightIcon className="h-5 w-5" data-id="element-211" data-mp="3tf4n0ms108fe" />
            </button>
          </div>
        </div>

        <div ref={trackRef} className="scrollbar-hide mt-10 flex snap-x snap-mandatory gap-5 overflow-x-auto pb-2" data-id="element-212" data-mp="1pdmgxnmkvvxq">
          {insideScreenshots.map(label => <div key={label} className="w-[78%] flex-shrink-0 snap-start sm:w-[55%] md:w-[calc(33.333%-14px)]" data-id="element-213" data-mp="236vorjuvo9e5">
              <PlaceholderMockup label={label} aspect="aspect-[4/3]" src={INSIDE_IMAGES[label]} alt={`Vista interior de Maestro en Pista — ${label}`} width={800} height={600} data-id="element-214" data-mp="2d2yn0emlznvt" />
            </div>)}
        </div>

        <p className="mx-auto mt-8 max-w-[650px] text-center text-sm leading-relaxed text-mp-gray md:text-base" data-id="element-215" data-mp="2h5v9whj6m65k">
          Esto es lo que podrás consultar antes de entrar en pista cuando necesites preparar, revisar o adaptar una
          sesión.
        </p>
      </Container>
    </section>;
}